<template>
  <div
    class="stepper-container d-flex align-items-center w-100"
    :class="{
      'py-3': $vuetify.breakpoint.xs,
      'py-4': !$vuetify.breakpoint.xs
    }"
  >
    <template v-for="(step, index) in steps">
      <div
        v-if="!$vuetify.breakpoint.xs || currentStep === step.value"
        :key="index"
        class="d-flex align-center step-item"
        :class="{
          'active': currentStep === step.value || step.isComplete,
          'w-100': $vuetify.breakpoint.xs,
          'max-width-100': $vuetify.breakpoint.xs
        }"
      >
        <slot>
          <VDivider
            v-if="index && !$vuetify.breakpoint.xs"
            class="stepper-divider"
          />
          <div
            class="step-body align-items-center px-3 d-flex cursor-pointer"
            @click="$emit('onStepClick', step.value)"
          >
            <div class="step-count">
              <span class="caption">
                <template v-if="step.isComplete && currentStep !== step.value">
                  <VIcon
                    small
                    color="textWhite"
                  >mdi-check</VIcon>
                </template>
                <template v-else>
                  {{ index + 1 }}
                </template>
              </span>
            </div>
            <div class="ml-2 step-body-content">
              <div class="step-title body-1">
                {{ step.title }}
              </div>
              <div class="step-sub-title caption textTertiary--text text-ellipsis-2-line">
                {{ step.subTitle }}
              </div>
            </div>
          </div>
        </slot>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Stepper',
};
</script>

<script setup lang="ts">
defineProps({
  currentStep: {
    type: String,
    default: '',
  },
  steps: {
    type: Array,
    default: () => [],
  },
});
</script>

<style scoped lang="scss">

.step-item {
  opacity: 1;
  color: #252525;
  max-width: 60%;
  &:first-child {
    max-width: 40%;
  }

  .step-title {
    width: 150px;
    color: #252525 !important;
  }

  .step-sub-title {
    color: #252525 !important;
  }

  &.max-width-100{
    max-width: 100%;
  }

  .step-body-content {
    width: 80%;
  }

  .step-count {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    text-align: center;
    color: #252525 !important;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      opacity: 0.2;
      background-color: #252525 !important;
    }
  }

  .stepper-divider {
    width: 50px;
    border-color: #252525 !important;
  }

  &.active {
    opacity: 1;
    .step-count {
      background: var(--v-brandingPrimary-base) !important;
      color: var(--v-textWhite-base) !important;
    }
  }
}

</style>
